// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: 利用設定の更新（変更したキーだけを送る）
const AdminOpsConfigUpdateApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_config_update";

    const ExecAdminOpsConfigUpdateApi = async (values) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: values });
    };

    return ExecAdminOpsConfigUpdateApi;
};

export default AdminOpsConfigUpdateApi;
